import React, { useState, useEffect } from "react";
import "./questionModal.css";

const DetailsModal = ({
  visible,
  onClose,
  onSubmit,
  current_ref = "",
  due_date = "",
  notes = "",
  pay = true,
  termsRequired = false,
  referenceEditable = true,
  confirmationLabel = "Quote confirmation",
}) => {
  const [ref, setRef] = useState(current_ref);
  const [dueDate, setDueDate] = useState(due_date);
  const [noteText, setNoteText] = useState(notes);
  const [terms, setTerms] = useState(false);

  const toInputValue = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const getNextWorkingDay = (baseDate) => {
    const d = new Date(
      baseDate.getFullYear(),
      baseDate.getMonth(),
      baseDate.getDate()
    );
    do {
      d.setDate(d.getDate() + 1);
    } while (d.getDay() === 0 || d.getDay() === 6);
    return d;
  };

  const handleNextWorkingDay = () => {
    const base = new Date();
    const next = getNextWorkingDay(base);
    setDueDate(toInputValue(next));
  };

  useEffect(() => {
    if (visible) {
      setRef(current_ref);
      setDueDate(due_date);
      setNoteText(notes);
      setTerms(false);
    }
  }, [visible, current_ref, due_date, notes]);

  if (!visible) return null;

  const handleSubmit = () => {
    if (termsRequired && !terms) return;

    onSubmit({
      current_ref: ref,
      due_date: dueDate,
      notes: noteText,
      terms: terms,
    });
  };

  const submitDisabled = termsRequired && !terms;

  return (
    <div
      className="modal_overlay quote-confirmation-modal-overlay"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <section
        className="modal_content quote-confirmation-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="quote-confirmation-modal-title"
      >
        <div className="quote-confirmation-modal__heading">
          <div>
            <span className="basket-panel-eyebrow">{confirmationLabel}</span>
            <h3 id="quote-confirmation-modal-title">Confirm details</h3>
            <p>Check the information below before continuing.</p>
          </div>
          <button
            type="button"
            className="basket-debug-modal__close"
            aria-label="Close confirmation"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <form
          className="quote-confirmation-modal__form"
          onSubmit={(event) => {
            event.preventDefault();
            handleSubmit();
          }}
        >
          <label className="quote-confirmation-modal__field">
            <span>Reference / PO number</span>
          <input
            type="text"
            value={ref}
            onChange={(e) => setRef(e.target.value)}
            readOnly={!referenceEditable}
            autoFocus={referenceEditable}
          />
          </label>

          <label className="quote-confirmation-modal__field">
            <span>Required by date</span>
            <div className="quote-confirmation-modal__date-row">
            <input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
            />
            <button
                className="quote-confirmation-modal__date-button"
              type="button"
              onClick={handleNextWorkingDay}
            >
              Next working day
            </button>
          </div>
            <small>
              We will endeavour to achieve this date. A team member will
              confirm availability.
            </small>
          </label>

          <label className="quote-confirmation-modal__field">
            <span>Delivery notes</span>
          <textarea
            rows="3"
            value={noteText}
            onChange={(e) => setNoteText(e.target.value)}
          />
          </label>

        {termsRequired && (
            <label className="quote-confirmation-modal__acknowledgement">
              <input
                type="checkbox"
                checked={terms}
                onChange={(e) => setTerms(e.target.checked)}
              />
              <span>
                <strong>Made-to-order products</strong>
                <small>
                  I acknowledge that this order contains NS lines or modified
                  materials which cannot be cancelled or returned.
                </small>
              </span>
            </label>
        )}

          <div className="quote-confirmation-modal__actions">
            <button
              type="button"
              className="button-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
          <button
              type="submit"
            className="pay_button"
            disabled={submitDisabled}
          >
            {pay === true ? "Make Payment" : "Accept Quote"}
          </button>
        </div>
        </form>
      </section>
    </div>
  );
};

export default DetailsModal;
